// Constants matching the React Native app

export const Spacings = {
  TINY: 4,
  EXTRA_SMALL: 8,
  SMALL: 12,
  MEDIUM: 16,
  LARGE: 24,
  EXTRA_LARGE: 48,
};

export const Colors = {
  PRIMARY: '#005499',
  LIGHTPRIMARY: '#0077B6',
  SECONDARY: '#0C0D34',
  WHITE: '#FFFFFF',
  GREY: '#F4F0EF',
  DARK_GREY: '#808080',
  DANGER: '#FF0058',
  YELLOW: '#EAC33A',
  GRAY_YELLOW: '#cfbf8a',
  DARKBLUE: '#4C7D91',
  CUSTOM_GREY: '#545454',
  CUSTOM_YELLOW: '#FFD600',
};

export const IconSizes = {
  MEDIUM: 24,
  SMALL: 16,
  LARGE: 32,
  SPECIAL_VIDEO_PLAYER_PLAY: 80,
};

export const Keys = {
  MAPS_KEY: 'AIzaSyDZxGbLlfCtduzITHpL2JaoOHYl3zLEyAM',
};

